/**
 * /!\ This file is auto-generated.
 *
 * This is the entry point of your standalone application.
 *
 * There are multiple tags used by the editor to inject code automatically:
 *     - `wle:auto-imports:start` and `wle:auto-imports:end`: The list of import statements
 *     - `wle:auto-register:start` and `wle:auto-register:end`: The list of component to register
 */

/* wle:auto-imports:start */
import {MouseLookComponent} from '@wonderlandengine/components';
import {WasdControlsComponent} from '@wonderlandengine/components';
import {MobileActiveSwitch} from './mobile-active-switch.js';
import {TouchLook} from './touch-look.js';
import {TouchMove} from './touch-move.js';
import {TouchUI} from './touch-ui.js';
/* wle:auto-imports:end */

export default function(engine) {
/* wle:auto-register:start */
engine.registerComponent(MouseLookComponent);
engine.registerComponent(WasdControlsComponent);
engine.registerComponent(MobileActiveSwitch);
engine.registerComponent(TouchLook);
engine.registerComponent(TouchMove);
engine.registerComponent(TouchUI);
/* wle:auto-register:end */
}
